export const formatCurrency = (value?: number | string) => {
    if (value === null || value === undefined || value === "") return "—";

    const numberValue = Number(value);

    if (isNaN(numberValue)) return "—";

    return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(numberValue);
};
